import React, { useState } from 'react';

interface LoginProps {
  onLogin: (token: string, email: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [token, setToken] = useState(window.localStorage.getItem('lastToken') || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token.trim()) {
      setError('Please enter a GCP token');
      return;
    }

    window.localStorage.setItem('lastToken', token);

    setLoading(true);
    setError('');

    try {
      // For testing, you can use these tokens:
      // admin_token - authorized admin user
      // user_token - another authorized user
      // Or use a real GCP token
      
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        onLogin(token, data.user.email);
      } else {
        setError(data.message || `Login failed (${response.status}): ${data.error || 'Unknown error'}`);
      }
    } catch (err) {
      setError(`Connection failed: ${err instanceof Error ? err.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">AA Troubleshooter</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="token" className="form-label">
              GCP Access Token
            </label>
            <input
              id="token"
              type="text"
              className="form-input"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Enter your GCP token or use admin_token for testing"
              disabled={loading}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div style={{ marginTop: '1rem', fontSize: '0.875rem', color: '#666' }}>
          <strong>Test Tokens:</strong><br />
          • admin_token - Admin access<br />
          • user_token - User access
        </div>
      </div>
    </div>
  );
};

export default Login;
